<!--
  @description: 财务结算-结算申请-申请提前收款
  @filePath:src\modules\transport\bms\views\finance\settleDetails\components\AdvanceCollection.vue
-->
<template>
    <div class="advanceCollection">
            <el-table :data="totalData" border height="auto" ref="advanceCollectionTable">
                <el-table-column show-overflow-tooltip :prop="item.prop" :label="item.label" v-for="(item, index) in config.table.columns"
                    :key="index" >
                </el-table-column>
                <el-table-column  label="操作" width="230">
                    <template slot-scope="scope">
                            <el-button v-for="(item, index) in config.table.action" :key="index" v-show="showBtnFn(item.event, scope.row)" :disabled="disabledFn(item.event, scope.row)" @click="handleClick(item.event, scope.row)" :loading="btnLoading" type="text" size="small">{{ item.label }}</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 协议弹窗 -->
        <FinalizationDialog ref="finalizationDialogRef_" iframeKey="AdvanceCollection" @finalizationSuccess="finalizationSuccess"></FinalizationDialog>
    </div>
</template>
<script>
import { dictWithUrl } from '@/components/lots/api';
import mTableMixin from '@/modules/transport/bms/mixins/mTableMixin.js';
import {
    queryApplyChange,
    recallApElectronic,
    submitApplyChange,
    abolishApplyChange
} from '@/modules/transport/bms/api/settleDetails.js';
import FinalizationDialog from '../dialog/FinalizationDialog.vue';

export default {
    name: 'AdvanceCollection',
    components: { FinalizationDialog },
    mixins: [mTableMixin],
    props: {
        apApplyNo: {
            type: [String, Number]
        },
        jobId: {
            type: [String, Number]
        }
    },
    watch: {
        apApplyNo: {
            immediate: true,
            handler: function () {
                this.queryList();
            }
        }
    },
    data() {
        return {
            btnLoading: false,
            config: {
                configuration: true,
                'table': {
                    'switchType': true,
                    'leftOperation': true,
                    'tableCut': false,
                    'clickState': false,
                    'isPagination': false,
                    'height': 'auto',
                    'columns': [
                        {
                            'label': '申请提前收款单号',
                            'prop': 'apApplyChangeNo',
                            'width': '50px'
                        },
                        {
                            'label': '申请提前收款日期',
                            'prop': 'createTime',
                            'width': '50px'
                        },
                        {
                            'label': '申请提前收款金额',
                            'prop': 'subNum1',
                            'width': '50px'
                        },
                        {
                            'label': '是否电子签章',
                            'prop': 'subStr1Name',
                            'type': 'select',
                            'optionNum': 'SRM_YES_NO',
                            'width': '40px'
                        },
                        {
                            'label': '是否生成收据',
                            'prop': 'subStr4Name',
                            'type': 'select',
                            'optionNum': 'SRM_YES_NO',
                            'width': '40px'
                        },
                        {
                            'label': '审核状态',
                            'prop': 'changeStatusName',
                            'type': 'select',
                            'optionNum': 'SYS_BMS_APPLY_CHANGE',
                            'width': '40px'
                        },
                        {
                            'label': '审核意见',
                            'prop': 'subStr2',
                            'width': '80px'
                        }
                    ],
                    'action': [
                        {
                            'type': 'text',
                            'label': '提交',
                            'size': 'small',
                            'event': 'submit'
                        },
                        {
                            'type': 'text',
                            'label': '重新提交',
                            'size': 'small',
                            'event': 'resubmit'
                        },
                        {
                            'type': 'text',
                            'label': '电子签章撤回',
                            'size': 'small',
                            'event': 'revoke'
                        },
                        {
                            'type': 'text',
                            'label': '电子签章',
                            'size': 'small',
                            'event': 'signature'
                        },
                        {
                            'type': 'text',
                            'label': '废弃',
                            'size': 'small',
                            'event': 'abandon'
                        },
                        {
                            'type': 'text',
                            'label': '查看收据',
                            'size': 'small',
                            'event': 'viewReceipt'
                        },
                        {
                            'type': 'text',
                            'label': '查看协议',
                            'size': 'small',
                            'event': 'viewProtocol'
                        }
                    ]
                },
                'page': {
                    'layout': 'total, sizes, prev, pager, next, jumper',
                    'pageSize': 10
                }
            }
        };
    },
    methods: {
        /** 查询 **/
        queryListExecute({ params, successCallback }) {
            if (!this.apApplyNo) return;
            params = { 'apApplyNo': this.apApplyNo };
            queryApplyChange(params).then(async (res) => {
                if (res && +res.code === 0) {
                    const dictRes = await dictWithUrl('SYS_BMS_APPLY_CHANGE,SRM_YES_NO');
                    res.data && res.data instanceof Array && res.data.forEach(el => {
                        el.createTime = el.createTime.substring(0, 10);
                        if (dictRes && +dictRes.code === 0) {
                            el.changeStatusName = dictRes.data['SYS_BMS_APPLY_CHANGE'][el.changeStatus.toString()];
                            el.subStr1 === '' && (el.subStr1 = '0');
                            el.subStr1Name = dictRes.data['SRM_YES_NO'][el.subStr1];
                            el.subStr4Name = dictRes.data['SRM_YES_NO'][el.subStr4];
                        }
                    });
                    this.$emit('resData', res);
                    successCallback(res);
                }
            });
        },
        /** 提交 **/
        handleSubmit({ apApplyChangeNo }) {
            if (!(apApplyChangeNo)) return;
            this.btnLoading = true;
            submitApplyChange({
                applyChangeNo: apApplyChangeNo,
                operate: 1 // 提交 1   审核2  废弃是3
            }).then(res => {
                if (res && +res.code === 0) {
                    this.queryList();
                    this.$message.success('提交成功');
                }
            }).finally(() => {
                this.btnLoading = false;
            });
        },
        /** 重新提交 **/
        handleResubmit({ apApplyChangeNo, subStr1 }) {
            if (!(apApplyChangeNo)) return;
            if ([0, '0'].includes(subStr1)) return this.$message.warning('电子签章已完成方能提交!');
            this.btnLoading = true;
            submitApplyChange({
                applyChangeNo: apApplyChangeNo,
                operate: 1 // 提交 1   审核2  废弃是3
            }).then(res => {
                if (res && +res.code === 0) {
                    this.queryList();
                    this.$message.success('重新提交成功');
                }
            }).finally(() => {
                this.btnLoading = false;
            });
        },
        /** 电子签章 **/
        handleSignature({ subStr1, apApplyChangeNo }) {
            if (!(this.jobId && this.apApplyNo)) return;
            if ([0, '0'].includes(subStr1)) {
                this.$emit('signature', { jobId: this.jobId, apApplyNo: this.apApplyNo, apApplyChangeNo });
                this.$refs.finalizationDialogRef_.handleVisible(true, JSON.parse(JSON.stringify({ jobId: this.jobId, apApplyNo: this.apApplyNo, apApplyChangeNo })));
            }
        },
        /** 电子签章撤回 **/
        handleRevoke({ jobId, apApplyNo, apApplyChangeNo }) {
            if (!(jobId && apApplyNo && apApplyChangeNo)) return;
            this.btnLoading = true;
            recallApElectronic({
                jobId, apApplyNo, applyChangeNo: apApplyChangeNo
            }).then(res => {
                if (res && +res.code === 0) {
                    this.queryList();
                    this.$message.success('电子签章撤回成功');
                }
            }).finally(() => {
                this.btnLoading = false;
            });
        },
        /** 废弃 **/
        handleAbandon({ apApplyChangeNo, jobId, subStr1, changeStatus }) {
            if (!(apApplyChangeNo && jobId)) return;
            if (![30, '30'].includes(changeStatus) && [1, '1'].includes(subStr1)) return this.$message.warning('请先撤回电子签章!');
            this.btnLoading = true;
            abolishApplyChange({
                applyChangeNo: apApplyChangeNo,
                jobId
            }).then(res => {
                if (res && +res.code === 0) {
                    this.queryList();
                    this.$emit('abandonSuccess', { apApplyChangeNo });
                    this.$message.success('废弃成功');
                }
            }).finally(() => {
                this.btnLoading = false;
            });
        },
        /** 查看收据 **/
        handleViewReceipt(row) {
            if (row.subStr4 === '0') return this.$message.warning('收据暂未生成，请在收据生成后重试');
            const url = row.afPrintUrl || '';
            url && window.open(url, '_blank');
        },
        /** 查看协议 **/
        handleViewProtocol(row) {
            const isSignet = [2, '2'].includes(row.lsrmPrintStatus); // 是否电子签章
            const url = row[(isSignet ? 'lsrmAfPrint2' : 'lsrmBfPrint2')] || '';
            url && window.open(url, '_blank');
        },
        handleClick(event, row) {
            const eventMap = {
                submit: this.handleSubmit,
                resubmit: this.handleResubmit,
                revoke: this.handleRevoke,
                signature: this.handleSignature,
                abandon: this.handleAbandon,
                viewReceipt: this.handleViewReceipt,
                viewProtocol: this.handleViewProtocol
            };
            eventMap[event](row);
        },
        showBtnFn(event, row) {
            const showBtnMap = {
                submit: [40, '40'],
                resubmit: [30, '30'],
                revoke: [40, '40'],
                signature: [40, '40'],
                abandon: [30, '30', 40, '40'],
                viewReceipt: [20, '20'],
                viewProtocol: [20, '20']
            };
            return showBtnMap[event].includes(row.changeStatus);
        },
        disabledFn(event, row) {
            const disabledAction = {
                viewProtocol: () => row.subStr4 === '0',
                signature: () => [1, '1'].includes(row.subStr1)
            };
            return disabledAction[event] && disabledAction[event]();
        },
        finalizationSuccess() {
            this.queryList();
        }
    },
    created() {
    }
};
</script>
<style lang="less" scoped>
.advanceCollection{
    /deep/ #myPane .row-bg{
        display: none !important;
    }
}
</style>
